import { render, staticRenderFns } from "./TableDataChart.vue?vue&type=template&id=315b0b6c&scoped=true"
import script from "./TableDataChart.vue?vue&type=script&lang=js"
export * from "./TableDataChart.vue?vue&type=script&lang=js"
import style0 from "./TableDataChart.vue?vue&type=style&index=0&id=315b0b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315b0b6c",
  null
  
)

export default component.exports